var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { lg: 7, md: 9, sm: 12, span: 6, xl: 6, xs: 24 } },
            [
              _c("img", {
                staticStyle: { width: "100%" },
                attrs: { alt: "", src: "images/detail-yunshu.png" },
              }),
            ]
          ),
          _c(
            "el-col",
            { attrs: { lg: 16, md: 14, sm: 12, span: 18, xl: 18, xs: 24 } },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "16px" } },
                [
                  _c("h2", [_vm._v("阳光物流行业雇主险（限广东企业）")]),
                  _c("p", [
                    _vm._v(
                      "\n\t\t\t\t\t① 3人起保，支持线上随时替换，替换率不限\n\t\t\t\t\t"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\t② 最高保额120万，社保用药、误工费、猝死有保障\n\t\t\t\t\t"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\t③ 误工费无免赔，100元/人/天，每次90天，累计180天\n\t\t\t\t\t"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\t④ 医疗费0免赔，医保范围内100%赔付\n\t\t\t\t\t"
                    ),
                    _c("br"),
                    _vm._v("\n\t\t\t\t\t⑤ 扩展24小时个人意外\n\t\t\t\t\t"),
                    _c("br"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "medium", type: "warning" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleInsure.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("立即投保")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.currentStep,
            callback: function ($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "保险详情", name: "0" } },
            [
              _c(
                "el-card",
                [
                  _c("avue-crud", {
                    ref: "crud",
                    attrs: {
                      "cell-style": _vm.onCellStyle,
                      data: _vm.dataPlan,
                      option: _vm.optionPlan,
                      "span-method": _vm.spanMethodPlan,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "赔付标准" } },
                [
                  _c("el-row", { attrs: { justify: "center", type: "flex" } }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-weight": "500",
                          color: "Red",
                          "margin-bottom": "20px",
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t社保用药范围100%赔付，伤残等级对应赔付比例请查看附表\n\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ]),
                  _c(
                    "avue-crud",
                    {
                      ref: "crud",
                      attrs: {
                        data: _vm.dataBenefit,
                        option: _vm.optionBenefit,
                      },
                    },
                    [_c("template", { slot: "header" })],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "常见问题", name: "1" } },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 20 } }, [
                    _c(
                      "ul",
                      _vm._l(_vm.dataQA, function (ref) {
                        var question = ref.question
                        if (question === void 0) question = ""
                        var answer = ref.answer
                        if (answer === void 0) answer = ""
                        return _c(
                          "li",
                          { key: question },
                          [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    width: "20px",
                                    "text-align": "center",
                                    "background-color": "MediumPurple",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\tQ\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "bold" } },
                                [_vm._v(_vm._s(question))]
                              ),
                            ]),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "margin-top": "12px",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      width: "20px",
                                      height: "28px",
                                      "background-color": "MediumSeaGreen",
                                      color: "white",
                                      padding: "4px",
                                      "border-radius": "4px",
                                      "margin-right": "8px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\tA\n\t\t\t\t\t\t\t\t"
                                    ),
                                  ]
                                ),
                                question ===
                                "中途是否可以加人？新增人员如何收费？"
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "inline-block",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t中途可以增加保障人员。保单新增人员时，保费按照剩余的保险月数进行计费，不足一个月的按照一个月计算。\n\t\t\t\t\t\t\t\t\t"
                                        ),
                                        _c(
                                          "table",
                                          {
                                            staticStyle: { margin: "15px" },
                                            attrs: {
                                              border: "1",
                                              cellpadding: "0",
                                              ellspacing: "0",
                                              width: "100%",
                                            },
                                          },
                                          [
                                            _c(
                                              "tr",
                                              {
                                                staticStyle: {
                                                  "text-align": "center",
                                                },
                                              },
                                              [
                                                _c("th", [
                                                  _vm._v("批增收费比例"),
                                                ]),
                                                _vm._l(
                                                  12,
                                                  function (item, index) {
                                                    return _c(
                                                      "th",
                                                      { key: index },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item) + "个月"
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                            _c(
                                              "tr",
                                              {
                                                staticStyle: {
                                                  "text-align": "center",
                                                },
                                              },
                                              [
                                                _c("td", [_vm._v("支付比例")]),
                                                _vm._l(
                                                  _vm.questionDataRate,
                                                  function (item) {
                                                    return _c("td", [
                                                      _vm._v(_vm._s(item)),
                                                    ])
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "white-space": "pre-wrap",
                                        },
                                      },
                                      [_vm._v(_vm._s(answer))]
                                    ),
                              ]
                            ),
                            _c("el-divider"),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "投保须知", name: "2" } },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 20 } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "line-height": "26px",
                          "white-space": "pre-line",
                        },
                      },
                      [
                        _c(
                          "h3",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "center",
                            },
                          },
                          [_vm._v("投保须知及重要事项告知")]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "line-height": "32px",
                              "white-space": "pre-line",
                            },
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t1、本保险适用以下保险条款： 2、本保险由阳光财产保险股份有限公司承保，\n\t\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "仅限承保营业执照注册地址在广东的企业和组织"
                              ),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t。 3、投保要求：企业名称\n\t\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v("不含“装卸”、“搬运”"),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t。\n\t\t\t\t\t\t\t4、在投保本保险前请您认真阅读《保险条款》，了解本保险的保险责任及责任免除，尤其是对其中免除保险人责任的条款(包括但不限于责任免除、投保人被保险人义务等)。在充分理解并接受上述内容的基础上，同意以此作为订立保险合同的依据。\n\t\t\t\t\t\t\t5、在投保本保险时您应如实填写各项投保信息以履行相应的如实告知义务，若故意或者因重大过失未履行如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同；\n\t\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费；\n\t\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。\n\t\t\t\t\t\t\t6、本保险合同以电子保单形式提供。根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，与纸质合同具有同样的法律效力。\n\t\t\t\t\t\t\t7、本保险根据投保单位的需求提供电子发票或纸质专票。 8、本保险由博维保险经纪有限公司面向\n\t\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v("广东省内销售并提供服务"),
                            ]),
                            _vm._v("\n\t\t\t\t\t\t\t。 9、\n\t\t\t\t\t\t\t"),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t鉴于被保险人的行业风险特性，本保单仅支持按年投保，不支持短期投保。保单可批增人员（不足1个月的按1个月收费）；在保单生效后申请退保或批减在保人员的，可退保费为0。\n\t\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t10、中途可以增加保障人员。\n\t\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t保单新增人员时，保费按照剩余的保险月数进行计费，不足一个月的按照一个月计算。\n\t\t\t\t\t\t\t"
                              ),
                            ]),
                            _c(
                              "table",
                              {
                                staticStyle: { margin: "15px" },
                                attrs: {
                                  border: "1",
                                  cellpadding: "0",
                                  ellspacing: "0",
                                  width: "100%",
                                },
                              },
                              [
                                _c(
                                  "tr",
                                  { staticStyle: { "text-align": "center" } },
                                  [
                                    _c("th", [_vm._v("批增收费比例")]),
                                    _vm._l(12, function (item) {
                                      return _c("th", [
                                        _vm._v(_vm._s(item) + "个月"),
                                      ])
                                    }),
                                  ],
                                  2
                                ),
                                _c(
                                  "tr",
                                  { staticStyle: { "text-align": "center" } },
                                  [
                                    _c("td", [_vm._v("支付比例")]),
                                    _vm._l(
                                      _vm.questionDataRate,
                                      function (item) {
                                        return _c("td", [_vm._v(_vm._s(item))])
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            ),
                            _vm._v("\n\t\t\t\t\t\t\t11、\n\t\t\t\t\t\t\t"),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t如从业人员驾驶无有效行驶证车辆或未持有合法有效驾驶证、酒驾或醉驾期间发生交通事故的，保险人不承担保险责任。若在运输途中，发生货物掉落、倾斜等情况，司机及随车人员因整理货物、篷布等操作导致意外事故属于保单责任。\n\t\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v("\n\t\t\t\t\t\t\t12、\n\t\t\t\t\t\t\t"),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t本保单不承保以下职业：外卖配送员、快递配送员、平台骑手、平台跑腿人员，如作业内容含有保险人不承保的职业类别工作内容，保险人不承担任何赔偿责任。\n\t\t\t\t\t\t\t"
                              ),
                            ]),
                          ]
                        ),
                        _c("el-divider"),
                        _c("h3", [_vm._v("特别约定")]),
                        _c("div", [
                          _c("h4", [_vm._v("1、保障期限：")]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t自所投保雇主责任保险生效日起，保险期限为一年。\n\t\t\t\t\t\t\t"
                          ),
                          _c("h4", [_vm._v("2、特别特约：")]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t（1）被保险人必须在保险事故发生后48小时内报案，因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任。如果被保险人\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("超过72小时才报案"),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t，则保险人对按保单约定的应承担的保险责任，\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("免赔50%。"),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t如果事故发生日期早于本保单生效日期，被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权提请相关机关追究被保险人及相关人员的法律责任。\n\t\t\t\t\t\t\t（2）被保险人从业人员的年龄限16-65周岁，本方案每人限投1份，超过部分无效。\n\t\t\t\t\t\t\t（3）鉴于被保险人的行业风险特性，本保单仅支持按年投保，不支持短期投保。保单可批增人员（不足1个月的按1个月收费）；\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "在保单生效后申请退保或批减在保人员的，可退保费为0。"
                            ),
                          ]),
                          _vm._v("\n\t\t\t\t\t\t\t（4）\n\t\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t如从业人员驾驶无有效行驶证车辆或未持有合法有效驾驶证、酒驾或醉驾期间发生交通事故的，保险人不承担保险责任。若在运输途中，发生货物掉落、倾斜等情况，司机及随车人员因整理货物、篷布等操作导致意外事故属于保单责任。\n\t\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v("\n\t\t\t\t\t\t\t（5）\n\t\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t（可选）本保单不承保货车司机和随车人员参与装卸货物有关工作发生的工伤和意外伤害的赔偿责任。\n\t\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t（6）医疗费用适用独立的赔偿限额，不包含在死亡、伤残赔偿限额之内，按照实际指定就诊医院所在地的（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准，每次事故医疗费用超过人民币0元部分按100%的比例赔付。\n\t\t\t\t\t\t\t（7）\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t被保险人从业人员从事高空（高处）作业时，必须按照国家相关安全管理规定（包括但不限于必须佩戴安全绳、安全带或者安装防护网等安全设施设备）执行；从事特种作业必须取得有效特种作业操作证（包括但不限高处作业证），\n\t\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("免赔25%。"),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t（8）本保单承保法律费用责任，累计赔偿限额为RMB10万元，每次事故赔偿限额为RMB10万元。\n\t\t\t\t\t\t\t（9）被保险人从业人员遭受伤害时，\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t实际从事的工作危险程度高于投保人明确告知保险人的工作类型的，则保险人对按保单约定的应承担的保险责任，免赔20%。如实际工作是装卸工或货车司乘人员投保了文员、仓管工种，保险人不承担任何赔偿责任。\n\t\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t（10）在工作时间和工作岗位，\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t突发疾病死亡或者在48小时之内经抢救无效死亡，保险人承担赔偿责任，每人最高赔偿限额=每人身故赔偿限额*20%。\n\t\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t（11）本保单伤残赔偿金：按伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）（以下称《伤残鉴定标准》）确定伤残等级而支付相应赔偿金。相应的赔偿限额为该伤残等级所对应的下列“伤残等级赔偿限额比例表”的比例乘以每人死亡赔偿限额所得金额。本保单适用伤残赔付比例按：一级伤残100％，二级伤残80％，三级伤残70％，四级伤残60％，五级伤残50％，六级伤残40％，七级伤残30％，\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("八级伤残20％，九级伤残10％，十级伤残5％。"),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t（12）误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算包含住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GA/T1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且一旦确定伤残程度后即刻停止误工费的计算。\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "被保险人从业人员仅接受门诊治疗的，按本保单约定无误工费赔付。"
                            ),
                          ]),
                          _vm._v("\n\t\t\t\t\t\t\t（13）\n\t\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "本保单指定就诊医院为大陆境内二级及以上公立医院。"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t如因紧急抢救无法前往本保单指定就诊医院，须在保险事故发生后72小时内转入本保单指定就诊医院。对于前往非本保单指定就诊医院或未按本约定转入本保单指定就诊医院所产生的医疗费用，除非取得保险人认可，否则保险人有权拒绝赔偿。\n\t\t\t\t\t\t\t（14）本保单附加24小时意外险特别扩展B（2022版）条款，扩展承保被保险人雇员在全天24小时内因意外事故而导致的死亡赔偿金、伤残赔偿金(或自伤残发生之日起在180日内发生死亡)以及因此而引起的意外医药费用（社保范围内用药）。其中，伤残鉴定标准按照《人身保险伤残评定标准（行业标准）》，伤残赔付比例按：一级伤残100％，二级伤残80％，三级伤残70％，四级伤残60％，五级伤残50％，六级伤残40％，七级伤残30％，\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t八级伤残20％，九级伤残10％，十级伤残5％。24小时意外险死亡伤残责任与雇主工伤死亡伤残责任共用限额，每人最高不超过保单列明的雇主工伤死亡伤残责任限额的50%；24小时意外险医疗责任与雇主工伤医疗责任共用限额，每人最高不超过保单列明的工伤医疗责任限额。\n\t\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t（15）本特别约定与主条款内容相悖之处，以本特约为准；未尽之处，以主条款为准。\n\t\t\t\t\t\t"
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }